<template>
  <div>
    <div v-for="(repair, index) in products" :key="repair.id">
      <h1 class="mb-8 font-bold text-3xl">
        <span class="text-indigo-400 hover:text-indigo-600">INFORMATIONS SUR LE POSTE {{ index+1 }}</span>
      </h1>
      <div class="md:inline-flex space-y-4 md:space-y-0 w-full max-w-7xl py-4 items-center">
          <div class="bg-white rounded shadow overflow-x-auto">
            <table class="w-full whitespace-no-wrap">
              <tr class="text-center font-bold">
                <th class="px-2 pt-6 pb-4">N° Order</th>
                <th class="px-2 pt-6 pb-4">IMEI</th>
                <th class="px-2 pt-6 pb-4">S/N</th>
                <th class="px-2 pt-6 pb-4">Modele</th>
                <th class="px-2 pt-6 pb-4">Operateur</th>
                <th class="px-2 pt-6 pb-4">Agence</th>
                <th class="px-2 pt-6 pb-4">Panne</th>
                <th class="px-2 pt-6 pb-4">Entré par</th>
                <th class="px-2 pt-6 pb-4">Sortie par</th>
                <th class="px-2 pt-6 pb-4">N°envoi</th>
                <th class="px-2 pt-6 pb-4">Prix TTC</th>
              </tr>
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t border-r">
                  <span class="px-2 py-4 flex items-center focus:text-indigo-500" >
                    {{ repair.id }}
                  </span>
                </td>
                <td class="border-t border-r">
                  <span class="px-2 py-4 flex items-center focus:text-indigo-500" >
                    {{ repair.imei }}
                  </span>
                </td>
                <td class="border-t border-r">
                  <span class="px-2 py-4 flex items-center focus:text-indigo-500" >
                    {{ repair.sn }}
                  </span>
                </td>
                <td class="border-t border-r">
                  <span class="px-2 py-4 flex items-center focus:text-indigo-500" >
                    {{ repair.model }}
                  </span>
                </td>
                <td class="border-t border-r">
                  <span class="px-2 py-4 flex items-center focus:text-indigo-500" >
                    {{ repair.operator }}
                  </span>
                </td>
                <td class="border-t border-r">
                  <span class="px-2 py-4 flex items-center focus:text-indigo-500" >
                    {{ repair.agency }}
                  </span>
                </td>
                <td class="border-t border-r">
                  <span class="px-2 py-4 flex items-center focus:text-indigo-500" >
                    {{ repair.malfunction }}
                  </span>
                </td>
                <td class="border-t border-r">
                  <span class="px-2 py-4 flex items-center focus:text-indigo-500" >
                    {{ repair.agent }}
                  </span>
                </td>
                <td class="border-t border-r">
                  <span class="px-2 py-4 flex items-center focus:text-indigo-500" >
                    {{ repair.shipped_by }}
                  </span>
                </td>
                <td class="border-t border-r">
                  <span class="px-2 py-4 flex items-center focus:text-indigo-500" >
                    {{ repair.shipping_no }}
                  </span>
                </td>
                <td class="border-t border-r">
                  <span class="px-2 py-4 flex items-center focus:text-indigo-500" >
                    {{ repair.price }}
                  </span>
                </td>
              </tr>
            </table>
            <table class="w-full whitespace-no-wrap">
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t w-1/6">
                  <span class="px-2 py-4 flex items-center text-white font-bold bg-gray-400">
                    Irreparable
                  </span>
                </td>
                <td class="border-t">
                  <span class="px-2 py-4 flex items-center">
                    {{ repair.irreparable_reason }} /  {{ repair.irreparable_comment }}
                  </span>
                </td>
              </tr>
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t w-1/6">
                  <span class="px-2 py-4 flex items-center text-white font-bold bg-gray-400">
                    Commentaire Reception
                  </span>
                </td>
                <td class="border-t">
                  <span class="px-2 py-4 flex items-center">
                    {{ repair.reception_comment }}
                  </span>
                </td>
              </tr>
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t w-1/6">
                  <span class="px-2 py-4 flex items-center text-white font-bold bg-gray-400">
                   Commentaire Technicien
                  </span>
                </td>
                <td class="border-t">
                  <span class="px-2 py-4 flex items-center">
                   {{ repair.tech_comment }}
                  </span>
                </td>
              </tr>
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t w-1/6">
                  <span class="px-2 py-4 flex items-center text-white font-bold bg-gray-400">
                   Commentaire Expedition
                  </span>
                </td>
                <td class="border-t">
                  <span class="px-2 py-4 flex items-center">
                   ..
                  </span>
                </td>
              </tr>
              <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t w-1/6">
                  <span class="px-2 py-4 flex items-center text-white font-bold bg-gray-400">
                   Réparation faites
                  </span>
                </td>
                <td class="border-t">
                  <span class="px-2 py-4 flex items-center">
                   {{ repair.repairs_done }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
      </div>

      <div class="md:w-full mx-auto grid grid-cols-2 gap-6">
        <div>
          <h1 class="mb-4 mt-4 font-bold text-3xl">
            <span class="text-indigo-400 hover:text-indigo-600">Pièces Demandées</span>
          </h1>
          <div class="md:inline-flex space-y-4 md:space-y-0 w-full max-w-7xl py-4 items-center">
            <div class="bg-white rounded shadow overflow-x-auto">
              <table class="w-full whitespace-no-wrap">
                <tr class="text-center font-bold">
                  <th class="px-6 pt-6 pb-4">Reference</th>
                  <th class="px-6 pt-6 pb-4">Quantité</th>
                  <th class="px-6 pt-6 pb-4">Date de demande</th>
                </tr>
                <tr v-for="part in repair.parts" :key="part.reference" class="hover:bg-gray-100 focus-within:bg-gray-100">
                  <td class="border-t border-r">
                  <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                    {{ part.reference }}
                  </span>
                  </td>
                  <td class="border-t border-r">
                  <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                    1
                  </span>
                  </td>
                  <td class="border-t border-r">
                  <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                    {{ part.created_at }}
                  </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="md:w-2/3 mx-auto grid grid-cols-6 gap-6">
      </div>

      <h1 class="mb-4 mt-4 font-bold text-3xl">
        <span class="text-indigo-400 hover:text-indigo-600">Traces du poste</span>
      </h1>
      <div class="md:inline-flex space-y-4 md:space-y-0 w-full max-w-7xl py-4 items-center">
        <div class="bg-white rounded shadow overflow-x-auto">
          <table class="w-full whitespace-no-wrap">
            <tr class="text-center font-bold">
              <th class="px-6 pt-6 pb-4">Role</th>
              <th class="px-6 pt-6 pb-4">Utilisateur</th>
              <th class="px-6 pt-6 pb-4">Etape</th>
              <th class="px-6 pt-6 pb-4">Status</th>
              <th class="px-6 pt-6 pb-4">Date</th>
            </tr>
            <tr v-for="trace in repair.trace" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t border-r">
                  <span class="px-6 py-4 flex items-center focus:text-indigo-500" >
                    {{ trace.role }}
                  </span>
              </td>
              <td class="border-t border-r">
                  <span class="px-6 py-4 flex items-center focus:text-indigo-500" >
                    {{ trace.user }}
                  </span>
              </td>
              <td class="border-t border-r">
                  <span class="px-6 py-4 flex items-center focus:text-indigo-500" >
                    {{ trace.step }}
                  </span>
              </td>
              <td class="border-t border-r">
                  <span class="px-6 py-4 flex items-center focus:text-indigo-500" >
                    {{ trace.status }}
                  </span>
              </td>
              <td class="border-t border-r">
                  <span class="px-6 py-4 flex items-center focus:text-indigo-500" >
                    {{ trace.date }}
                  </span>
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import Layout from '@/Layouts/AppLayout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'

export default {
  metaInfo: {title: 'Details'},
  layout: Layout,
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  props: {
    products: Array,
  },
  remember: 'form',
  data() {
    return {
      sending: false,
      form: {},
    }
  },
  methods: {},
}
</script>
